import {ClickerGameLayers} from '../../ClickerGame.constants';
import {DI_TOKENS} from '@/di/di.tokens';
import {Sprite, Texture} from 'pixi.js';

import {injected} from 'brandi';

import {IGameObject} from '@specials/gcs-engine';

import {PixiViewComponent} from '@/gcs/PixiViewComponent';

import {ClickerGameAssetsLoader} from '../../ClickerGameAssetsLoader';
import {CometaDataComponent, CometaType} from './CometaDataComponent';

export class CometaViewComponent extends PixiViewComponent {
  private dataComponent?: CometaDataComponent;

  constructor(private readonly assetsLoader: ClickerGameAssetsLoader) {
    super();
  }

  public onAddToGameObject(go: IGameObject): void {
    super.onAddToGameObject(go);
    this.dataComponent = go.getComponent(CometaDataComponent);
  }

  public renderView(): Sprite {
    const type = this.dataComponent?.cometaType;

    if (type === undefined) throw new Error('todo');

    const sprite = new Sprite(this.getSpriteByType(type));
    sprite.scale.set(0.5);
    sprite.zIndex = ClickerGameLayers.BonusesLayer;

    return sprite;
  }

  private getSpriteByType(type: CometaType): Texture {
    switch (type) {
      case 1:
        return this.assetsLoader.bundle.comet1;

      case 2:
        return this.assetsLoader.bundle.comet2;

      case 3:
        return this.assetsLoader.bundle.comet3;

      case 4:
        return this.assetsLoader.bundle.comet4;

      default:
        return this.assetsLoader.bundle.comet1;
    }
  }
}

injected(CometaViewComponent, DI_TOKENS.clickerGameAssetsLoader);
